// ECharts 4 按需引入统一入口。
// 所有业务代码请 `import echarts from "@/plugins/echarts"`，
// 不要再直接 `import echarts from "echarts"`，否则会把整包 (~700KB) 打进 vendor。
// 新增图表/组件时，把对应模块加到下面即可。
import echarts from "echarts/lib/echarts"

// 图表
import "echarts/lib/chart/line"
import "echarts/lib/chart/bar"
import "echarts/lib/chart/pie"
import "echarts/lib/chart/scatter"

// 组件
import "echarts/lib/component/grid"
import "echarts/lib/component/tooltip"
import "echarts/lib/component/legend"
import "echarts/lib/component/dataZoom"
import "echarts/lib/component/visualMap"
import "echarts/lib/component/markLine"
import "echarts/lib/component/title"
import "echarts/lib/component/axisPointer"
import "echarts/lib/component/geo"

export default echarts
